class HomeVideoBannerLanding extends HTMLElement {
  constructor() {
    super();
    $(document).ready(function () {
      var url_string = window.location.href;
      var url = new URL(url_string);
      var make = url.searchParams.get("make");
      var model = url.searchParams.get("model");
      var year = url.searchParams.get("year");
      var csvurl = $(".car-cover-main-container").data("csvfile");
      var maintitle = $(".car-cover-main-container").data("title");
      var handle = $(".car-cover-main-container").data("url");
      var jsonarr = [];
      console.log("tesst" + csvurl);

      $(".yearselect").attr("disabled", "true");
      $.ajax({
        type: "GET",
        url: csvurl,
        dataType: "text",
        success: function (data) {
          var csvData = data;
          let word_array = $.csv.toArrays(csvData);

          for (let index = 1; index < word_array.length; index++) {
            var ob = {};
            ob["category"] = word_array[index][0];
            ob["year"] = word_array[index][1];
            ob["make"] = word_array[index][2];
            ob["model"] = word_array[index][3];
            ob["title"] = word_array[index][4];
            ob["images"] = word_array[index][5];
            ob["instock"] = word_array[index][6];
            ob["price"] = word_array[index][7];
            ob["compprice"] = word_array[index][8];
            ob["tags"] = word_array[index][9];
            jsonarr.push(ob);
          }
          setSelectTags(jsonarr);
          $(".buttons-container").show();
        },
      });

      function setSelectTags(jsonarr) {
        var hasyear = false;
        var hasmake = false;
        var hasmodel = false;
        var namestr = "";

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        $.each(jsonarr, function (index, value) {
          if (urlParams.has("year")) {
            var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();
            if (value.year.toUpperCase() == yeartag) {
              hasyear = true;
            }
          }
        });

        $.each(jsonarr, function (index, value) {
          if (urlParams.has("make")) {
            var maketag = "MAKE_" + urlParams.get("make").toUpperCase();
            if (value.make.toUpperCase() == maketag) {
              hasmake = true;
            }
          }
        });

        $.each(jsonarr, function (index, value) {
          if (urlParams.has("model")) {
            var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();
            if (value.model.toUpperCase() == modeltag) {
              hasmodel = true;
            }
          }
        });

        if (hasmodel == true && hasmake == true) {
          $(".yearselectbox").css("order", 3);
          $(".makeselectbox").css("order", 1);
          $(".modelselectbox").css("order", 2);
          namestr = urlParams.get("make") + " " + urlParams.get("model");
          var maketag = "MAKE_" + urlParams.get("make").toUpperCase();
          var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();

          var makes = [];
          var selyear = $(this).val();
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              makes.push(value.make);
            }
          });
          makes.sort();
          var strmake =
            '<option value="Select Make" disabled>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var selected = "";
            if (ma.toUpperCase() == maketag) {
              selected = "selected";
            }
            strmake =
              strmake +
              `<option value='${ma.replace(".", "")}' ${selected}>${
                ma.split("_")[1]
              }</option>`;
          }
          $(".makeselect").html(strmake);
          $(".makeselect").removeAttr("disabled");

          var models = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (value.make.toUpperCase() == maketag) {
                models.push(value.model);
              }
            }
          });
          models.sort();
          var modelhtml =
            '<option value="Select Model" disabled>Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            var selected = "";
            if (mo.toUpperCase() == modeltag) {
              selected = "selected";
            }
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}' ${selected}>${
                mo.split("_")[1]
              }</option>`;
          }
          $(".modelselect").html(modelhtml);
          $(".modelselect").removeAttr("disabled");

          var years = [];

          var datasearch = {};

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              if (
                value.make.toUpperCase() == maketag &&
                value.model.toUpperCase() == modeltag
              ) {
                years.push(value.year);
                
              }
            }
          });

          years.sort();

          var yearhtml =
            '<option value="Select Year" disabled selected>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var ye = years[i];
            yearhtml =
              yearhtml +
              `<option value='${ye.replace(".", "")}'>${
                ye.split("_")[1]
              }</option>`;
          }
          $(".yearselect").html(yearhtml);
          $(".yearselect").removeAttr("disabled");

          $(".makeselect").change(function () {
            namestr = $(this).val().split("_")[1];
            $(".makeselect").val($(this).val());
            var models = [];
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.make == selmake) {
                  models.push(value.model);
                  
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              console.log(models[i]);
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(".modelselect").html(modelhtml);
            $(".modelselect").removeAttr("disabled");
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            $(".yearselect").html(yearhtml);
            $(".yearselect").attr("disabled", true);
          });

          $(".modelselect").change(function () {
            $(".modelselect").val($(this).val());
            var years = [];

            var datasearch = {};
            var selmake = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val();
            var selmodel = $(this).val();
            namestr = selmake.split("_")[1] + " " + $(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.year, years) === -1) {
                if (
                  value.make.toUpperCase() == selmake.toUpperCase() &&
                  value.model.toUpperCase() == selmodel.toUpperCase()
                ) {
                  years.push(value.year);
                  
                }
              }
            });

            years.sort();

            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            for (var i = 0; i < years.length; i++) {
              var ye = years[i];
              yearhtml =
                yearhtml +
                `<option value='${ye.replace(".", "")}'>${
                  ye.split("_")[1]
                }</option>`;
            }
            $(".yearselect").html(yearhtml);
            $(".yearselect").removeAttr("disabled");
          });

          $(".yearselect").change(function () {
            $(".yearselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc.split(" ").join("-") +
              "+" +
              makec.split(" ").join("-") +
              "+" +
              smodelc.split(" ").join("-");

            var redurl =
             
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];
            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == true && hasmodel == true) {
          namestr = urlParams.get("year") + " " + urlParams.get("model");
          $(".yearselectbox").css("order", 1);
          $(".modelselectbox").css("order", 2);
          $(".makeselectbox").css("order", 3);

          var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();
          var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();

          var years = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              years.push(value.year);
            }
          });

          years.sort();
          years.reverse();
          var stryear =
            '<option value="Select Year" disabled>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var yy = years[i];
            var selected = "";
            if (yy.toUpperCase() == yeartag) {
              selected = "selected";
            }
            stryear =
              stryear +
              `<option value='${yy}' ${selected}>${yy.split("_")[1]}</option>`;
          }
          $(".yearselect").html(stryear);
          $(".yearselect").removeAttr("disabled");

          var models = [];

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (value.year.toUpperCase() == yeartag) {
                models.push(value.model);
              }
            }
          });
          models.sort();
          var modelhtml =
            '<option value="Select Model" disabled >Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            var selected = "";
            if (mo.toUpperCase() == modeltag) {
              selected = "selected";
            }
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}' ${selected}>${
                mo.split("_")[1]
              }</option>`;
          }
          $(".modelselect").html(modelhtml);
          $(".modelselect").removeAttr("disabled");

          $(".yearselect").change(function () {
            namestr = $(this).val().split("_")[1];
            $(".yearselect").val($(this).val());
            var models = [];
            var selyear = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear) {
                  models.push(value.model);
                  
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(".modelselect").html(modelhtml);
            $(".modelselect").removeAttr("disabled");
            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            $(".makeselect").html(makehtml);
            $(".makeselect").attr("disabled", true);
          });

          $(".modelselect").change(function () {
            $(".modelselect").val($(this).val());
            var makes = [];

            var datasearch = {};
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmodel = $(this).val();
            namestr = selyear.split("_")[1] + " " + $(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (
                  value.year.toUpperCase() == selyear.toUpperCase() &&
                  value.model.toUpperCase() == selmodel.toUpperCase()
                ) {
                  makes.push(value.make);
                  
                }
              }
            });

            makes.sort();

            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              makehtml =
                makehtml +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(".makeselect").html(makehtml);
            $(".makeselect").removeAttr("disabled");
          });

          var makes = [];

          var datasearch = {};

          var found = false;

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (
                value.year.toUpperCase() == yeartag &&
                value.model.toUpperCase() == modeltag
              ) {
                makes.push(value.make);
                
                found = true;
              }
            }
          });

          makes.sort();

          var makehtml =
            '<option value="Select Make" disabled selected>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            makehtml =
              makehtml +
              `<option value='${ma.replace(".", "")}'>${
                ma.split("_")[1]
              }</option>`;
          }
          $(".makeselect").html(makehtml);
          $(".makeselect").removeAttr("disabled");

          $(".makeselect").change(function () {
            $(".makeselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc.split(" ").join("-") +
              "+" +
              makec.split(" ").join("-") +
              "+" +
              smodelc.split(" ").join("-");

            var redurl =
             
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];
            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == true && hasmake == true) {
          namestr = urlParams.get("year") + " " + urlParams.get("make");
          $(".yearselectbox").css("order", 1);
          $(".makeselectbox").css("order", 2);
          $(".modelselectbox").css("order", 3);

          var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();
          var maketag = "MAKE_" + urlParams.get("make").toUpperCase();

          var years = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              years.push(value.year);
            }
          });

          years.sort();
          years.reverse();
          var stryear =
            '<option value="Select Year" disabled>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var yy = years[i];
            var selected = "";
            if (yy.toUpperCase() == yeartag) {
              selected = "selected";
            }
            stryear =
              stryear +
              `<option value='${yy}' ${selected}>${yy.split("_")[1]}</option>`;
          }
          $(".yearselect").html(stryear);
          $(".yearselect").removeAttr("disabled");

          var makes = [];

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (value.year.toUpperCase() == yeartag) {
                makes.push(value.make);
              }
            }
          });
          makes.sort();
          var makehtml =
            '<option value="Select Make" disabled >Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var selected = "";
            if (ma.toUpperCase() == maketag) {
              selected = "selected";
            }
            makehtml =
              makehtml +
              `<option value='${ma.replace(".", "")}' ${selected}>${
                ma.split("_")[1]
              }</option>`;
          }
          $(".makeselect").html(makehtml);
          $(".makeselect").removeAttr("disabled");

          $(".yearselect").change(function () {
            namestr = $(this).val().split("_")[1];
            $(".yearselect").val($(this).val());
            var makes = [];

            var datasearch = {};
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();

            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year.toUpperCase() == selyear.toUpperCase()) {
                  makes.push(value.make);
                  
                }
              }
            });

            makes.sort();

            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              makehtml =
                makehtml +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(".makeselect").html(makehtml);
            $(".makeselect").removeAttr("disabled");
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            $(".modelselect").html(modelhtml);
            $(".modelselect").attr("disabled", true);
          });

          $(".makeselect").change(function () {
            $(".makeselect").val($(this).val());
            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
            namestr = selyear.split("_")[1] + " " + $(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                  
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(".modelselect").html(modelhtml);
            $(".modelselect").removeAttr("disabled");
          });

          var models = [];

          var datasearch = {};

          var found = false;

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (
                value.year.toUpperCase() == yeartag &&
                value.make.toUpperCase() == maketag
              ) {
                models.push(value.model);
                
                found = true;
              }
            }
          });

          models.sort();

          var modelhtml =
            '<option value="Select Model" disabled selected>Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}'>${
                mo.split("_")[1]
              }</option>`;
          }
          $(".modelselect").html(modelhtml);
          $(".modelselect").removeAttr("disabled");

          $(".modelselect").change(function () {
            $(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var smodelc = modelc.split("/").join("-");
            var strpartn =
              yearc.split(" ").join("-") +
              "+" +
              makec.split(" ").join("-") +
              "+" +
              smodelc.split(" ").join("-");

            var redurl =
             
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];
            localStorage.clear();
            window.location.href = redurl;
          });
        }

        if (hasyear == false && hasmodel == false && hasmake == false) {
          namestr = maintitle;
          $(".yearselectbox").css("order", 1);
          $(".makeselectbox").css("order", 2);
          $(".modelselectbox").css("order", 3);

          var datasearch = jsonarr[0];
          var years = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              years.push(value.year);
            }
          });
          years.sort();
          years.reverse();
          var stryear =
            '<option value="Select Year" disabled selected>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var yy = years[i];
            stryear =
              stryear + `<option value='${yy}'>${yy.split("_")[1]}</option>`;
          }
          $(".yearselect").html(stryear);
          $(".yearselect").removeAttr("disabled");
          $(".yearselect").change(function () {
            $(".yearselect").val($(this).val());
            $(".amfinder-reset").show();

            $(".modelselect").html(
              '<option value="Please Select" disabled selected>Loading..</option>'
            );
            $(".makeselect").html(
              '<option value="Please Select" disabled selected>Loading..</option>'
            );

            var makes = [];
            var selyear = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year == selyear) {
                  makes.push(value.make);
                }
              }
            });
            makes.sort();
            var strmake =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              var valma = ma.replace(".", "");
              valma = valma.replace("'", "");
              valma = valma.replace('"', "");
              strmake =
                strmake +
                `<option value='${valma}'>${ma.split("_")[1]}</option>`;
            }
            $(".makeselect").html(strmake);
            $(".makeselect").removeAttr("disabled");
            $(".modelselect").html(
              '<option value="Select Model" disabled selected>Select Model</option>'
            );
            $(".modelselect").attr("disabled", true);
          });
          $(".makeselect").change(function () {
            $(".makeselect").val($(this).val());
            $(".amfinder-reset").show();
            console.log($(this).val());
            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              console.log(models[i]);
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(".modelselect").html(modelhtml);
            $(".modelselect").removeAttr("disabled");
          });

          $(".modelselect").change(function () {
            $(".modelselect").val($(this).val());
            $(".search--button").removeAttr("disabled");
          });

          //$(".search--button").click(function ()
          $(".modelselect").change(function () {
            $(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var smodelc = modelc.split("/").join("-");
            var redurl =
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];

            localStorage.clear();
            window.location.href = redurl;
          });
        }

         if (hasyear == true && hasmodel == false && hasmake == false) {
          namestr = maintitle;
          $(".yearselectbox").css("order", 1);
          $(".makeselectbox").css("order", 2);
          $(".modelselectbox").css("order", 3);

          var yeartag = "YEAR_" + urlParams.get("year").toUpperCase();

          var found = false;
          var datasearch = {};
          var years = [];
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.year, years) === -1) {
              years.push(value.year);
            }
          });

          years.sort();
          years.reverse();
          var stryear =
            '<option value="Select Year" disabled>Select Year</option>';
          for (var i = 0; i < years.length; i++) {
            var yy = years[i];
            var selected = "";
            if (yy.toUpperCase() == yeartag) {
              selected = "selected";
            }
            stryear =
              stryear +
              `<option value='${yy}' ${selected}>${yy.split("_")[1]}</option>`;
          }
          $(".yearselect").html(stryear);
          $(".yearselect").removeAttr("disabled");

          $(".modelselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );
          $(".makeselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );

          var makes = [];
          var selyear = yeartag;
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (value.year == selyear) {
                makes.push(value.make);
                if (found == false) {
                  
                  found = true;
                }
              }
            }
          });
          makes.sort();
          var strmake =
            '<option value="Select Make" disabled selected>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var valma = ma.replace(".", "");
            valma = valma.replace("'", "");
            valma = valma.replace('"', "");
            strmake =
              strmake + `<option value='${valma}'>${ma.split("_")[1]}</option>`;
          }
          $(".makeselect").html(strmake);
          $(".makeselect").removeAttr("disabled");
          $(".modelselect").html(
            '<option value="Select Model" disabled selected>Select Model</option>'
          );
          $(".modelselect").attr("disabled", true);

          $(".yearselect").change(function () {
            
            $(".yearselect").val($(this).val());
            var makes = [];

            var datasearch = {};
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();

            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (value.year.toUpperCase() == selyear.toUpperCase()) {
                  makes.push(value.make);
                  
                }
              }
            });

            makes.sort();

            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              makehtml =
                makehtml +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(".makeselect").html(makehtml);
            $(".makeselect").removeAttr("disabled");
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            $(".modelselect").html(modelhtml);
            $(".modelselect").attr("disabled", true);
            
          });

          $(".makeselect").change(function () {
            $(".makeselect").val($(this).val());
            $(".amfinder-reset").show();
            console.log($(this).val());
            var models = [];
            var selyear = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val();
            var selmake = $(this).val();
           
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.year == selyear && value.make == selmake) {
                  models.push(value.model);
                  
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
              console.log(models[i]);
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(".modelselect").html(modelhtml);
            $(".modelselect").removeAttr("disabled");
            
          });

          $(".modelselect").change(function () {
            $(".modelselect").val($(this).val());
            $(".search--button").removeAttr("disabled");
          });

          $(".modelselect").change(function () {
            $(".modelselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var smodelc = modelc.split("/").join("-");
            var redurl =
              
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];

            localStorage.clear();
            window.location.href = redurl;
          });
          
        }

        if (hasyear == false && hasmodel == true && hasmake == false) {
          
          $(".makeselectbox").css("order", 2);
          $(".modelselectbox").css("order", 1);
          $(".yearselectbox").css("order", 3);

          var modeltag = "MODEL_" + urlParams.get("model").toUpperCase();

          var models = [];

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
                models.push(value.model);
            }
          });
          models.sort();
          var modelhtml =
            '<option value="Select Model" disabled >Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            var selected = "";
            if (mo.toUpperCase() == modeltag) {
              selected = "selected";
            }
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}' ${selected}>${
                mo.split("_")[1]
              }</option>`;
          }
          $(".modelselect").html(modelhtml);
          $(".modelselect").removeAttr("disabled");

          var makes = [];

          var datasearch = {};

          var found = false;

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (value.model.toUpperCase() == modeltag) {
                makes.push(value.make);
                if (found == false) {
                  
                  found = true;
                }
              }
            }
          });

          makes.sort();

          var makehtml =
            '<option value="Select Make" disabled selected>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            makehtml =
              makehtml +
              `<option value='${ma.replace(".", "")}'>${
                ma.split("_")[1]
              }</option>`;
          }
          $(".makeselect").html(makehtml);
          $(".makeselect").removeAttr("disabled");

          $(".yearselect").html(
            '<option value="Select Year" disabled selected>Select Year</option>'
          );
          $(".yearselect").attr("disabled", true);

          $(".modelselect").change(function () {
            $(".modelselect").val($(this).val());
            var makes = [];

            var datasearch = {};
          
            var selmodel = $(this).val();
            namestr =$(this).val().split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.make, makes) === -1) {
                if (
                  value.model.toUpperCase() == selmodel.toUpperCase()
                ) {
                  makes.push(value.make);
                  
                }
              }
            });

            makes.sort();

            var makehtml =
              '<option value="Select Make" disabled selected>Select Make</option>';
            for (var i = 0; i < makes.length; i++) {
              var ma = makes[i];
              makehtml =
                makehtml +
                `<option value='${ma.replace(".", "")}'>${
                  ma.split("_")[1]
                }</option>`;
            }
            $(".makeselect").html(makehtml);
            $(".makeselect").removeAttr("disabled");
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            $(".yearselect").html(yearhtml);
            $(".yearselect").attr("disabled", true);
            
          });

          $(".makeselect").change(function () {
            $(".makeselect").val($(this).val());
            $(".amfinder-reset").show();
            var years = [];
            var selmodel = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val();
            var selmake = $(this).val();
            namestr =$(this).val().split("_")[1] + ' ' + modeltag.split("_")[1];
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.year, years) === -1) {
                if (
                  value.model.toUpperCase() == selmodel.toUpperCase() &&
                  value.make.toUpperCase() == selmake.toUpperCase()
                ) {
                  years.push(value.year);
                  
                }
              }
            });
            years.sort();
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            for (var i = 0; i < years.length; i++) {
              console.log(years[i]);
              var ye = years[i];
              var valyear = ye.replace(".", "");
              valyear = valyear.replace("'", "");
              valyear = valyear.replace('"', "");
              yearhtml =
                yearhtml +
                `<option value='${valyear}'>${ye.split("_")[1]}</option>`;
            }
            $(".yearselect").html(yearhtml);
            $(".yearselect").removeAttr("disabled");
            
          });

          $(".yearselect").change(function () {
            $(".yearselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var smodelc = modelc.split("/").join("-");
            var redurl =
              
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];

            localStorage.clear();
            window.location.href = redurl;
          });
          
        }

        if (hasyear == false && hasmodel == false && hasmake == true) {
         
          $(".makeselectbox").css("order", 1);
          $(".modelselectbox").css("order", 2);
          $(".yearselectbox").css("order", 3);

          var maketag = "MAKE_" + urlParams.get("make").toUpperCase();

          var makes = [];
          
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              makes.push(value.make);
            }
          });
          makes.sort();
          var strmake =
            '<option value="Select Make" disabled>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var selected = "";
            if (ma.toUpperCase() == maketag) {
              selected = "selected";
            }
            strmake =
              strmake +
              `<option value='${ma.replace(".", "")}' ${selected}>${
                ma.split("_")[1]
              }</option>`;
          }
          $(".makeselect").html(strmake);
          $(".makeselect").removeAttr("disabled");

          var models = [];

          var datasearch = {};

          var found = false;

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (value.make.toUpperCase() == maketag) {
                models.push(value.model);
                if (found == false) {
                  
                  found = true;
                }
              }
            }
          });

          models.sort();

          var modelhtml =
            '<option value="Select Model" disabled selected>Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}'>${
                mo.split("_")[1]
              }</option>`;
          }
          $(".modelselect").html(modelhtml);
          $(".modelselect").removeAttr("disabled");

          $(".yearselect").html(
            '<option value="Select Year" disabled selected>Select Year</option>'
          );
          $(".yearselect").attr("disabled", true);

          $(".makeselect").change(function () {
            $(".makeselect").val($(this).val());
            var models = [];
            var selmake = $(this).val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.model, models) === -1) {
                if (value.make == selmake) {
                  models.push(value.model);
                  
                }
              }
            });
            models.sort();
            var modelhtml =
              '<option value="Select Model" disabled selected>Select Model</option>';
            for (var i = 0; i < models.length; i++) {
             
              var mo = models[i];
              var valmo = mo.replace(".", "");
              valmo = valmo.replace("'", "");
              valmo = valmo.replace('"', "");
              modelhtml =
                modelhtml +
                `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
            }
            $(".modelselect").html(modelhtml);
            $(".modelselect").removeAttr("disabled");
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            $(".yearselect").html(yearhtml);
            $(".yearselect").attr("disabled", true);
            
          });

          $(".modelselect").change(function () {
            $(".modelselect").val($(this).val());
            $(".amfinder-reset").show();
            var years = [];
            var selmodel = $(this).val().toUpperCase();
            var selmake = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val();
            $.each(jsonarr, function (index, value) {
              if ($.inArray(value.year, years) === -1) {
                if (
                  value.model.toUpperCase() == selmodel &&
                  value.make.toUpperCase() == selmake.toUpperCase()
                ) {
                  years.push(value.year);
                  
                }
              }
            });
            console.log(years);
            years.sort();
            var yearhtml =
              '<option value="Select Year" disabled selected>Select Year</option>';
            for (var i = 0; i < years.length; i++) {
              
              var ye = years[i];
              var valyear = ye.replace(".", "");
              valyear = valyear.replace("'", "");
              valyear = valyear.replace('"', "");
              yearhtml =
                yearhtml +
                `<option value='${valyear}'>${ye.split("_")[1]}</option>`;
            }
            $(".yearselect").html(yearhtml);
            $(".yearselect").removeAttr("disabled");
            
          });

          $(".yearselect").change(function () {
            $(".yearselect").val($(this).val());
            var yearc = $(this)
              .parents(".select-wrapper")
              .find(".yearselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var makec = $(this)
              .parents(".select-wrapper")
              .find(".makeselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            makec = makec.replace("/", "-");
            var modelc = $(this)
              .parents(".select-wrapper")
              .find(".modelselect")
              .val()
              .replace(".", "")
              .replace("&", "%26")
              .toLowerCase();
            var smodelc = modelc.split("/").join("-");
            var redurl =
              
              handle +
              "?year=" +
              yearc.split("_")[1] +
              "&make=" +
              makec.split("_")[1] +
              "&model=" +
              modelc.split("_")[1];

            localStorage.clear();
            window.location.href = redurl;
          });
          
        }

        if (hasyear == true && hasmodel == true && hasmake == true) {
           
          var redurl =
            handle +
            "?year=" +
            urlParams.get("year") +
            "&make=" +
            urlParams.get("make") +
            "&model=" +
            urlParams.get("model");

          localStorage.clear();
          window.location.href = redurl;
        }
      }
    });
  }
}

customElements.define("home-video-banner-landing", HomeVideoBannerLanding);
